import { useLocalStore } from 'mobx-react-lite';

import Entities from 'STORE';
import { User } from 'STORE/Users/User/User';

interface IGroupFormGeneralMembersPresenterParams {
  membersIds: string[];
}

interface IGroupFormGeneralMembersPresenter {
  members: User[];
  keyExtractor(contact: User): string;
}

export const useGroupFormGeneralMembersPresenter = (
  data: IGroupFormGeneralMembersPresenterParams
): IGroupFormGeneralMembersPresenter => {
  const { membersIds } = data;

  const presenter = useLocalStore<IGroupFormGeneralMembersPresenter>(() => ({
    get members(): User[] {
      return membersIds.map((id) => Entities.usersStore.getUserById(id)).filter(Boolean) as User[];
    },

    keyExtractor(contact: User): string {
      return contact.id;
    },
  }));

  return presenter;
};
